/* global attachEvent */

// *******************************************************************************
// 1.0 - Close Thank You Modal
// *******************************************************************************

attachEvent('.thankyou-modal__close', 'click', (ev) => {
  const parentEle = ev.target.closest('.thankyou-modal');
  parentEle.classList.remove('is-open-modal');
  ev.preventDefault();
});

// *******************************************************************************
// 2.0 - Close Thank You Modal When Escape Key Press
// *******************************************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.thankyou-modal').forEach((el) => {
      el.classList.remove('is-open-modal');
    });
  }
});
